import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { fetchUser } from 'services/users';
import { updateRole } from 'store/userReducer';

export const useUser = () => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);

    const onChangeRole = (roleUuid) => {
        dispatch(updateRole(roleUuid));
    };

    return {
        user,
        onChangeRole
    };
};

export const useFetchUser = (uuid) => {
    const { isPending, isError, data } = useQuery({
        queryKey: [uuid],
        queryFn: () => fetchUser(uuid)
    });

    return {
        user: data?.data || {},
        isLoading: isPending,
        error: isError
    };
};
